// extracted by mini-css-extract-plugin
module.exports = {"main":"GreyBlock__main___3bTjN","pulse":"GreyBlock__pulse___lnMXg"};